export const POST_ANALYSIS = 'ANALYSIS';
export const POST_BLOG = 'BLOG';
export const POST_TICKET = 'TICKET';

export const BETTABLE = 'BETTABLE';
export const TIME_3HOURS = '3HOURS';
export const TIME_TODAY = 'TODAY';
export const TIME_TOMORROW = 'TOMORROW';

export const SORTING_RECOMMENDED = 'RECOMMENDED';
export const SORTING_TOP = 'TOP';
export const SORTING_NEW = 'NEWEST';
export const SORTING_VIEWS = 'VIEWS';
export const SORTING_COMMENTS = 'COMMENTS';
export const SORTING_INSPIRATIONS = 'INSPIRATIONS';
export const postTypeUrl2Enum = {
    analyzy: POST_ANALYSIS,
    tikety: POST_TICKET,
    clanky: POST_BLOG,
    vsetky: null
};
export const postTypeEnum2Url = {
    [POST_ANALYSIS]: 'analyzy',
    [POST_TICKET]: 'tikety',
    [POST_BLOG]: 'clanky'
};
export const sortingUrl2Enum = {
    recommended: SORTING_RECOMMENDED,
    top: SORTING_TOP,
    new: SORTING_NEW,
    comments: SORTING_COMMENTS,
    inspirations: SORTING_INSPIRATIONS,
    views: SORTING_VIEWS
};
export const sortingEnum2Url = {
    [SORTING_TOP]: 'top',
    [SORTING_NEW]: 'new',
    [SORTING_RECOMMENDED]: 'recommended',
    [SORTING_COMMENTS]: 'comments',
    [SORTING_INSPIRATIONS]: 'inspirations',
    [SORTING_VIEWS]: 'views'
};

export type BetbooPostTypeOptions = keyof typeof postTypeEnum2Url;
export type BetboookPostsSortTypeOpions = keyof typeof sortingEnum2Url;

export function toBetbookQueryParams({
    sortType,
    byDate
}: {
    sortType?: BetboookPostsSortTypeOpions;
    byDate?: string;
}) {
    return {
        sorting: sortType ? sortingEnum2Url[sortType] : undefined,
        byDate: byDate ? byDate : undefined
    };
}

export function toBetbookPathParams(postType: BetbooPostTypeOptions) {
    return {
        postType: postType ? postTypeEnum2Url[postType] : null
    };
}

export function toBetbookAuthorPathParams(nickname: string, postType?: BetbooPostTypeOptions) {
    return {
        nickname,
        postType: postType ? postTypeEnum2Url[postType] : null
    };
}

export const timeUrl2Enum = { dnes: TIME_TODAY, zajtra: TIME_TOMORROW };
export const timeEnum2Url = { [TIME_TODAY]: 'dnes', [TIME_TOMORROW]: 'zajtra' };

export const ANALYSIS_PATTERN = /{(\bAnalysis\b):([a-zA-Z_0-9-.:]+):(-?[\d.,]+):([\d.,]+):(.*?)}/g;
